export const trackListRoute = () => '/tracks';
export const trackDetailRoute = (
  id: string,
  revision?: string,
  comment?: string
) =>
  `/tracks/${id}${revision ? `?revision=${revision}` : ''}${comment ? `&comment=${comment}` : ''
  }`;
